import AgGrid from '../AgGrid/AgGrid';
import React, { useEffect, useState } from 'react';
import MySelect from '../Layout/MySelect';
import moment from 'moment/moment';
import { Modal } from '@mui/material';
import MyButton from '../Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import TopBar from '../Layout/TopBar';
import useAuthz from '../../hooks/useAuthz';
import CheckboxRenderer from '../AgGrid/CheckboxRenderer';
import CheckboxRender from '../AgGrid/CheckboxRenderer';

const GrilleTarifaireTable = (props) => {
  const { openModal, handleCloseModal, grillesTarifaires, listAllCenters, listCenters, setGridSelectedValues} = props;
  const [authz, user, profil] = useAuthz();
  const [agGridOptions, setAgGridOptions] = useState({
    suppressCellSelection: true,
    suppressHorizontalScroll: false,
    animateRows: true,
  });
  const frameworkComponents = {
    'checkRenderer': CheckboxRender,
  }
  const [filters, setFilters] = useState({
    centre_id: null,
  });
  const [selectedCenters, setSelectedCenters] = useState([]);
  const grilleTarifaireColumns = [
    {
      headerName: 'Id',
      field: 'tarif_id',
      flex: 1,
      minWidth: 75,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Centre',
      field: 'centre_id',
      flex: 1,
      minWidth: 200,
      sortable: true,
      cellStyle: { 'justify-content': 'flex-start' },
      valueGetter: (params) => {
        let centerLabel = '';

        if (params.data.centre_id && listAllCenters.length > 0) {
          listAllCenters.map((center) => {
            if (center.id === params.data.centre_id)
              centerLabel = center.label;
          });
        }

        return centerLabel;
      },
      filter: 'agSetColumnFilter',
    }, {
      headerName: 'Libellé',
      field: 'libelle',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Unité',
      field: 'unite',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: `Date d'effet`,
      field: 'date_effet',
      flex: 1,
      minWidth: 200,
      sortable: true,
      valueFormatter: (params) => (params.data.date_effet ? moment(params.data.date_effet).format('DD/MM/YYYY HH:mm') : '-'),
      filter: 'agDateColumnFilter',
    },
    {
      headerName: 'Date de fin de validité',
      field: 'date_fin_validite',
      flex: 1,
      minWidth: 225,
      sortable: true,
      valueFormatter: (params) => (params.data.date_fin_validite ? moment(params.data.date_fin_validite).format('DD/MM/YYYY HH:mm') : '-'),
      filter: 'agDateColumnFilter',
    },
    {
      headerName: 'Tarif ( HT )',
      field: 'tarif',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agNumberColumnFilter',
    },
    {
      headerName: 'Sélection',
      field: 'selected',
      flex: 1,
      minWidth: 200,
      sortable: true,
      cellRenderer: 'checkRenderer',
      cellRendererParams: {
        setGridSelectedValues: setGridSelectedValues,
      },
    }
  ];

  const css = {
    container: { height: '90%', width: '90%', backgroundColor: 'white', borderRadius: '5px', overflow: 'hidden' },
  }

  const handleFilterChange = (e) => {
    if (e.target.name === 'centre_id') {
        setSelectedCenters(e.target.value);
        if (e.target.value === null || e.target.value.length === 0) {
            setFilters({ ...filters, [e.target.name]: null });
        } else {
            let labels = [];
            e.target.value.map((id) => {
                listAllCenters.map((center) => {
                    if (center.id === id) {
                        labels.push(center.label);
                    }
                });
            });

            setFilters({ ...filters, [e.target.name]: labels });
        }
    } else {
      setFilters({ ...filters, [e.target.name]: e.target.value ?? null });
    }
  };

  const onValidateSelectionBtnClick = () => {
    handleCloseModal();
  }

  return <Modal open={openModal} style={{ display: 'flex', width: '100%', backgroundColor: "transparent" }} disableEscapeKeyDown={true}>
    <div className='modal'>
      <div style={css.container}>
        <TopBar title={"Grille tarifaire"}
                className='topbar-contenu'
                color={'#0094ca'}
                buttons={<div className='topbar-buttons'>
                            <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} />
                        </div>}
        />

        <div style={{ display: 'flex', flexDirection: 'column', height: '95%' }}>
          <div className='row' style={{ flexWrap: 'nowrap', justifyContent: 'left', height: 'calc(15% + 10px)' }}>
            <MySelect
              labelClass={'select-label-black'}
              name={'centre_id'}
              label={'CENTRE'}
              disableClass={true}
              style={{ minWidth: '220px' }}
              displayLabel={true}
              datas={listAllCenters}
              value={selectedCenters}
              multiple={true}
              handleChange={handleFilterChange}
            />
          </div>
          <div style={{ height: '90%' }}>
            <div style={{ height: '100%', width: '100%', borderTop: '1px solid #4db4da' }}>
              <AgGrid
                gridName='ag-grid-grille-tarifaire-table'
                rowData={grillesTarifaires}
                columnDefs={grilleTarifaireColumns}
                rowHeight={40}
                pagination={false}
                gridOptions={agGridOptions}
                setGridOptions={setAgGridOptions}
                frameworkComponents={frameworkComponents}
                sortable={false}
                filters={filters}
              />
            </div>
          </div>

          <div className='row' style={{ justifyContent: 'flex-end', alignItems: 'center', height: '10%', margin: '20px' }}>
            <MyButton onClick={onValidateSelectionBtnClick} style={'buttonValidation'}
                      label={'Valider la sélection'} icon={faCheck} />
          </div>
        </div>
      </div>
    </div>
  </Modal>;
};

export default GrilleTarifaireTable;